import { render } from "./FooterCopyright.vue?vue&type=template&id=59e36b38"
import script from "./FooterCopyright.vue?vue&type=script&lang=js"
export * from "./FooterCopyright.vue?vue&type=script&lang=js"

import exportComponent from "/Users/farhad/Hemsidan/fartow-se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__